<template>
    <v-popover popoverInnerClass="p-2" class="d-inline-block ml-2">
        <span class="text-muted app-rounded-btn-container pt-1">
            <i class="fal fa-ellipsis-h fa-lg"></i>
        </span>
        <template v-slot:popover>
            <!--            <template v-if="authParamPaths.length !== 0">-->
            <!--                <div class="text-muted font-12">Connected as</div>-->
            <!--                <div v-for="path in authParamPaths"-->
            <!--                     :key="path.join('')"-->
            <!--                     @click="onConnectionClick(path)"-->
            <!--                     class="actions-menu-item">-->
            <!--                    {{ getConnectionName(_.get(recipe, path)) }}-->
            <!--                </div>-->
            <!--                <div class="dropdown-divider"></div>-->
            <!--            </template>-->
            <div @click="onDelete" class="actions-menu-item media">
                <div class="actions-icon align-self-center">
                    <i class="fal fa-trash-alt pr-1"></i>
                </div>
                <div class="media-body align-self-center">
                    Delete
                </div>
            </div>
        </template>
    </v-popover>
</template>

<script>

export default {
    name: 'AutomationBoardItemActions',
    // props: {
    //     recipe: { // AutomationRecipe
    //         type: Object,
    //         required: true
    //     }
    // },
    computed: {
        // authParamPaths() {
        //     return getRecipeAuthParamsPaths(this.recipe)
        // }
    },
    methods: {
        onDelete() {
            this.$emit('delete')
        },

        onConnectionClick(path) {
            this.$emit('connection-click', path)
        }

        // getConnectionName(param) {
        //     return `${_.get(param, 'label') || 'Unknown app'}:
        //     ${_.get(param, 'value.name') || 'Unknown connection'}`
        // }
    }
}
</script>

<style scoped lang="scss">
.actions-menu-item {
    padding: 4px 8px 4px 8px;
    min-width: 140px;

    &:hover {
        cursor: pointer;
        background-color: $color-purple-soft;
    }

}

</style>
